<template>
    <div class="d-flex flex-column">
        <div v-if="value && value['id']">
            <b-link :to="{ name: 'requestsDetail', params: { id: value['id'] } }">№{{value.id}}</b-link>
            <small class="d-flex text-secondary flex-nowrap nowrap">
                <request-status-indicator :request="value"/>
            </small>
        </div>
        <span v-else>&mdash;</span>
        <slot name="secondary">
        </slot>
    </div>
</template>

<script>
    import RequestStatusIndicator from "@/pages/AppPages/Requests/RequestStatusIndicator.vue";

    export default {
        name: "RequestNumberStatusCell",
        components: {RequestStatusIndicator},
        props: {
            value: { }
        }
    }
</script>

<style scoped>

</style>